// TODO: Find way to import from tailwind.js
export const breakpoints = {
    xs: 640,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1600,
}
